<app-session-lock-warning></app-session-lock-warning>
<app-pwa-banners></app-pwa-banners>

<!-- Full screen login when not authenticated -->
@if (!showLayout) {
  <div class="full-screen-container">
    <router-outlet></router-outlet>
  </div>
}

<!-- Main app layout when authenticated -->
@if (showLayout) {
  <nz-layout class="app-layout">
    @if (!isFullscreen()) {
      <nz-sider
        class="sidebar"
        [class.overlay-mode]="isOverlayMode"
        [class.overlay-expanded]="isOverlayExpanded"
        nzCollapsible
        nzWidth="300px"
        [nzCollapsedWidth]="80"
        [nzCollapsed]="siderCollapsed"
        (nzCollapsedChange)="onCollapsedChange($event)"
        [nzTrigger]="null"
      >
        <app-sidebar
          [isCollapsed]="isCollapsed"
          [canToggle]="isOverlayMode"
          (isCollapsedChange)="onCollapsedChange($event)"
          logoTitle="YuZeat"
          logoUrl="assets/logo/yuzeat.png"
          logoLink="/"
        >
        </app-sidebar>
      </nz-sider>
    }
    <nz-layout>
      <nz-content>
        <app-training-mode-banner></app-training-mode-banner>
        <div class="inner-content" [class.inner-content--fullscreen]="isFullscreen()">
          <router-outlet></router-outlet>
        </div>
      </nz-content>
    </nz-layout>
  </nz-layout>
}
